import SmoothScroll from 'smooth-scroll';
const scroll = new SmoothScroll('a[href*="#"]');


